import React from 'react';
import { Alert, Button, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Displays a single banner alert with optional actions.
 * Used by the banner queue system to show the highest priority banner.
 * 
 * @param {Object} banner - Banner configuration object
 * @param {Function} onDismiss - Callback when banner is dismissed (receives banner type)
 */
export const BannerDisplay = ({ banner, onDismiss }) => {
  if (!banner) return null;
  
  const handleDismiss = () => {
    if (banner.dismissible && onDismiss) {
      onDismiss(banner.type);
    }
  };
  
  return (
    <Box sx={{ mb: 2 }}>
      <Alert
        severity={banner.severity || 'info'}
        onClose={banner.dismissible ? handleDismiss : undefined}
        sx={{
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }
        }}
      >
        {/* Banner message */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <Box sx={{ flex: 1 }}>
            {banner.title && (
              <Box sx={{ fontWeight: 600, mb: banner.message ? 0.5 : 0 }}>
                {banner.title}
              </Box>
            )}
            {banner.message && (
              <Box sx={{ fontSize: '0.875rem' }}>
                {banner.message}
              </Box>
            )}
          </Box>
          
          {/* Action buttons */}
          {banner.actions && banner.actions.length > 0 && (
            <Box sx={{ display: 'flex', gap: 1, ml: 2 }}>
              {banner.actions.map((action, index) => (
                <Button
                  key={index}
                  size="small"
                  variant={action.variant || 'text'}
                  onClick={action.onClick}
                  sx={{ 
                    textTransform: 'none',
                    fontWeight: 600,
                    whiteSpace: 'nowrap'
                  }}
                >
                  {action.label}
                </Button>
              ))}
            </Box>
          )}
        </Box>
      </Alert>
    </Box>
  );
};


